const experiences = [
  {
    year: 2021,
    works: [
      {
        name: "Front-end Developer",
        company: "Freelancing",
        desc: "Working with React JS.",
      },
    ],
  },
  {
    year: 2022,
    works: [
      {
        name: "Back-end Developer",
        company: "Freelancing",
        desc: "Contrary to popular belief, Lorem Ipsum is not simply random text.",
      },
    ],
  },
];
export default experiences;
